import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';

const resources = {
  en: {
    translation: translationEN
  },
};
const getStoredLanguage = () => {
  try {
    return localStorage.getItem('language');
  } catch {
    return null;
  }
};

const getBrowserLanguage = () => {
  const preferredLanguage = getStoredLanguage();
  if (preferredLanguage) {
    return preferredLanguage;
  }
  if (navigator.languages && navigator.languages.length) {
    return navigator.languages[0];
  }
  return 'en';
};

const userLang = getBrowserLanguage();

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: userLang,
    nonExplicitSupportedLngs: true,
    supportedLngs: ["en", "es"],
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    fallbackLng: "en"
  });

export default i18n;
